var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="" data-menuregion="editManualOrderMode">\n	<div title="Per Drag & Drop auf die gewünschte Stelle schieben.">\n		<div class="MenuItem '+
((__t=( hasData.index ? 'MenuAccent' : '' ))==null?'':__t)+
'" data-favcustomizeview="enter">\n			<div class="MenuInline MenuIcon">\n				<i class="fa fa-hand-stop-o"></i>\n			</div>\n			<div class="MenuInline MenuLabel">Verschieben</div>\n		</div>\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));
